/** Thrillion customer-support staff (shared staff routes / sidebar). */
export const THRILLION_SUPPORT_ROLE_IDS = [7, 13, 14];

export function isThrillionSupportStaffRole(roleValue) {
  const roleNum = Number(roleValue);
  if (!Number.isNaN(roleNum) && THRILLION_SUPPORT_ROLE_IDS.includes(roleNum)) {
    return true;
  }
  const roleText = String(roleValue ?? "").toLowerCase().replace(/\s+/g, "_");
  return (
    roleText === "staff" ||
    roleText === "thrillionite_customer_support" ||
    roleText === "thrillionite_customer_support_lead" ||
    roleText === "thrillionite_customer_support_manager"
  );
}

export function getDefaultRouteByRole(roleValue) {
  const roleNum = Number(roleValue);
  const roleText = String(roleValue ?? "").toLowerCase();

  if (roleNum === 8 || roleText === "super_admin" || roleText === "superadmin") {
    return "/super-admins-dashboard";
  }

  if (
    roleNum === 15 ||
    roleText === "vendor_admin" ||
    roleText === "vendoradmin"
  ) {
    return "/vendor/dashboard";
  }

  if (
    roleNum === 16 ||
    roleText === "vendor_staff" ||
    roleText === "vendorstaff"
  ) {
    return "/staff-dashboard";
  }

  if (roleNum === 11 || roleText === "luxehara") {
    return "/luxehara/luxehara-dashboard";
  }

  if (
    roleNum === 3 ||
    roleNum === 4 ||
    roleText === "faculty" ||
    roleText === "class_teacher"
  ) {
    return "/faculty-dashboard";
  }

  if (isThrillionSupportStaffRole(roleValue)) {
    return "/staff-dashboard";
  }

  if (
    roleNum === 1 ||
    roleNum === 2 ||
    roleText === "admin" ||
    roleText === "school_admin" ||
    roleText === "school_head" ||
    roleText === "schoolhead" ||
    roleText === "principal"
  ) {
    return "/dashboard";
  }

  if (roleNum === 9 || roleText === "clerk") {
    return "/clerk-dashboard";
  }

  return "/dashboard";
}
